export const stats = [
	{ value: '100%', label: 'Client Satisfaction' },
	{ value: '10+', label: 'Years in Tech' },
	{ value: '1:1', label: 'Personal Attention' },
	{ value: '∞', label: 'Growth Potential' },
];
